const lngs = {
	'Select Hour': 'Select Hour',
	'Select Minute': 'Select Minute',
	'Select Second': 'Select Second',
	'January_February_March_April_May_June_July_August_September_October_November_December': 'January_February_March_April_May_June_July_August_September_October_November_December',
	'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec': 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec',
	'Su_Mo_Tu_We_Th_Fr_Sa': 'Su_Mo_Tu_We_Th_Fr_Sa',
	'Cancel': 'Cancel',
	'Confirm': 'Confirm',

	'Start new reservation'				: 'Start new reservation',

	'Kilometer'	: 'Kilometer',
	'Logout'	: 'Logout',
	'Wollen Sie sich wirklich von C-Share abmelden?': 'Wollen Sie sich wirklich von C-Share abmelden?',
	'Ja' : 'Ja',
	'Nein': 'Nein',
	'Meine Daten': 'Meine Daten',
	'Ändern' : 'Ändern',
	'Passwort ändern' : 'Passwort ändern',
};


const dictionary = {
  en: {
    attributes: {
      email: 'Email Address',
      pin: 'PIN',
      password: 'Password',
      firstname: 'First name',
      lastname: 'Last name',
      city: 'City',
      street: 'Street',
      zipcode: 'Zip code',
      phone: 'Phone'
    }
  },
  de: {
    attributes: {
      email: 'E-Mail',
      pin: 'PIN',
      password: 'Passwort',
      firstname: 'Vorname',
      lastname: 'Nachname',
      city: 'Ort',
      street: 'Straße',
      zipcode: 'Postleitzahl',
      phone: 'Telefon'
    }
  }
};



export default {
	en: {
		...lngs,
		...dictionary.en,
		'Book here and get started with the app:': 'Book here and get started with the app:',
		'We got your car!'	: 'We got your car!',
		'Loading'			: 'Loading',
		'FAQ'				: 'FAQ',

		/**
		 * ######################## FORMS AND INPUTS
		 */
		// Reservation
		'Start reservation'			: 'Start reservation',
		'Select the vehicle'		: 'Select the vehicle',
		'Station'					: 'Station',
		'please select'				: 'please select',
		'Selection and next step'	: 'Selection and next step',
		'Select the location'		: 'Select the location',
		'Continue to time selection': 'Continue to time selection',
		'Select the period'			: 'Select the period',
		'Pick-up time'				: 'Pick-up time',
		'Drop-off time'				: 'Drop-off time',
		'Planned kilometres'		: 'Planned kilometres',
		'Continue to vehicle selection' : 'Continue to vehicle selection',
		'Change' 					: 'Change',
		'Select'					: 'Select',
		'not available' 			: 'Not available',
		'Details'					: 'Details',
		'Book now'					: 'Book now',
		'Complete your reservation'	: 'Complete your reservation',
		'Personal data'				: 'Personal data',

		// Personals
		'Contact details'		: 'Contact details',
		'Login details'			: 'Login details',
		'Salutation'			: 'Salutation',
		'Mr.'					: 'Mr.',
		'Ms.'					: 'Ms.',
		'Fullname'				: 'Name',
		'First name'			: 'First name',
		'Last name'				: 'Last name',
		'Address'				: 'Anschrift',
		'Zip code'				: 'Zip code',
		'City'					: 'City',
		'Street, number'		: 'Street, number',
		'Email address'			: 'Email address',
		'Repeat e-mail address'	: 'Repeat e-mail address',
		'Repeat Password'		: 'Repeat Password',
		'Telephone number'		: 'Telephone number',
		'IBAN'					: 'IBAN',
		'BIC'					: 'BIC',
		'Car'					: 'Car',

		'Your message'			: 'Your Message',
		'Submit'				: 'Submit',

		// Summary
		'Buy at cost'			: 'Buy at cost',
		'Price'					: 'Price',
		'Period'				: 'Period',

		/**
		 * ######################## Menu
		 */
		'Menu'					: 'Menu',
		'Login'					: 'Login',
		'password'				: 'Password',
		'Home'					: 'Home',
		'Logging in'			: 'Logging in',
		'Register'				: 'Register',
		'Register for free'		: 'Register for free',
		'Register now'			: 'Register now',
		'Contact'				: 'Contact',
		'Instructions & FAQ'	: 'Instructions & FAQ',
		'Privacy policy'		: 'Privacy policy',
		'Imprint'				: 'Imprint',

		'Reservation'				: 'Reservation',
		'My C-Share': 'My C-Share',

		/**
		 * ######################## Footer
		 */
		'Download the C-Share app from your App Store': 'Download the C-Share app from your App Store',
	},
  	de: {
  		...lngs,
  		...dictionary.de,

  		'Book here and get started with the app:': 'Reserviere einfach dein Lieblingsfahrzeug:',
  		'We got your car!'	: 'Wir haben dein Auto!',
  		'Loading'			: 'Laden, bitte warten.',
		'FAQ'				: 'FAQ',

  		/**
		 * ######################## FORMS AND INPUTS
		 */
		// Reservation
		'Start reservation'			: 'Reservierung beginnen',
		'Select the vehicle'		: 'Wähle dein Fahrzeug',
		'Station'					: 'Station',
		'please select'				: 'bitte wählen',
		'Selection and next step'	: 'Auswahl und nächster Schritt',
		'Select the location'		: 'Wähle deinen Ort',
		'Continue to time selection': 'Weiter zur Zeitauswahl',
		'Select the period'			: 'Wähle den Zeitraum',
		'Pick-up time'				: 'Startzeit',
		'Drop-off time'				: 'Zielzeit',
		'Planned kilometres'		: 'Geplante Kilometer',
		'Continue to vehicle selection' : 'Weiter zur Fahrzeugwahl',
		'Change' 					: 'Ändern',
		'Select'					: 'Auswählen',
		'not available' 			: 'Nicht verfügbar',
		'Details'					: 'Details',
		'Book now'					: 'Jetzt reservieren',
		'Complete your reservation'	: 'Schliesse deine Reservierung ab',
		'Personal data'				: 'Persönliche Angaben',

  		// Personals
  		'Contact details'		: 'Kontaktdaten',
  		'Salutation'			: 'Anrede',
		'Mr.'					: 'Herr',
		'Ms.'					: 'Frau',
		'Fullname'				: 'Name',
		'First name'			: 'Vorname',
		'Last name'				: 'Nachname',
		'Address'				: 'Anschrift',
		'Zip code'				: 'Postleitzahl',
		'City'					: 'Ort',
		'Street, number'		: 'Straße, Haus-Nr.',
		'Email address'			: 'E-Mail',
		'Repeat e-mail address'	: 'E-Mail wiederholen',
		'Telephone number'		: 'Telefon',
		'IBAN'					: 'IBAN',
		'BIC'					: 'BIC',
		'Car'					: 'Fahrzeug',

		'Your message'			: 'Ihre Nachricht',
		'Submit'				: 'Absenden',

		// Summary
		'Buy at cost'			: 'Kostenpflichtig abschicken',
		'Price'					: 'Preis',
		'Period'				: 'Zeitraum',


		'Your vehicle is reserved!'		: 'Dein Fahrzeug ist reserviert!',
		'To overview'					: 'Zur Übersicht',
		'Until 1 hour before the start time you have the possibility to change or cancel the booking again.': 'Du hast bis 1 Stunde vor der Startzeit die Möglichkeit die Buchung noch einmal zu ändern oder zu stornieren.',

		/**
		 * ######################## Menu
		 */
		'Menu'					: 'Menu',
		'Login'					: 'Anmelden',
		'password'				: 'Passwort',
		'Home'					: 'Startseite',
		'Logging in'			: 'Einloggen',
		'Register'				: 'Registrieren',
		'Register for free'		: 'Kostenlos registrieren',
		'Register now'			: 'Jetzt registrieren',
		'Contact'				: 'Kontakt',
		'Instructions & FAQ'	: 'Anleitung & FAQ',
		'Privacy policy'		: 'Datenschutz',
		'Imprint'				: 'Impressum',

		'Reservation'				: 'Meine Reservierung',
		'My C-Share': 'Mein C-Share',

		/**
		 * ######################## Footer
		 */
		'Download the C-Share app from your App Store': 'Hol dir die C-Share App kostenlos aus dem App Store'
  	},
};



// WEBPACK FOOTER //
// ./src/i18n.js